<template>
	<div class="l-edit-dialog-box" style="height: 600px">
		<el-steps :active="active" align-center>
			<el-step title="企业基础信息" description=""></el-step>
			<el-step title="添加超级管理员" description=""></el-step>
			<el-step title="添加设备类型" description=""></el-step>
		</el-steps>
		<!--第一步-->
		<div v-show="active == 1">
			<l-company-add-step1 @on-success="addCompanySuccess" :company-name="companyName" :review-id="reviewId"></l-company-add-step1>
		</div>

		<!--第二步-->
		<div v-show="active == 2">
			<l-company-add-step2 :org-id="org_id" @on-click-last-step="lastStep" @on-success="nextStep" :user-name="userName" :mobile="mobile"></l-company-add-step2>
		</div>

		<!--第三步-->
		<div v-show="active == 3">
			<l-company-add-step3 :org-id="org_id" @on-click-last-step="lastStep" @on-success="cancel"></l-company-add-step3>
		</div>
	</div>
</template>

<script>
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
export default {
	name: "l-company-add",
	props: {
		companyName: {
			type: String,
			default: "",
		},

		userName: {
			type: String,
			default: "",
		},

		mobile: {
			type: String,
			default: "",
		},

		reviewId: {
			type: [Number, String],
			default: "",
		},
	},
	components: {
		[Step1.name]: Step1,
		[Step2.name]: Step2,
		[Step3.name]: Step3,
	},
	data() {
		return {
			active: 1,
			org_id: "",
		};
	},
	methods: {
		//点击取消通知父组件关闭对话框
		cancel() {
			this.$emit("on-success");
			this.$emit("update:visible", false);
		},

		//添加企业成功
		addCompanySuccess(id) {
			this.org_id = id;
			this.$emit("on-company-add-success");
			this.nextStep();
		},
		//下一步
		nextStep() {
			this.active++;
		},
		//上一步
		lastStep() {
			this.active--;
		},
	},
};
</script>
